import React from "react";
import PropTypes from "prop-types";
import { clsx } from "clsx";
import Icon from "../../../../components/Icon";

const SummaryBlock = React.forwardRef((props, ref) => {
  const {
    count,
    title,
    subtitle,
    titleLabel,
    icon,
    overflowHidden,
    children,
    className,
    actions = null,
    hashValue = null,
    id
  } = props;
  const blockActions = !!actions?.length && (
    <div className="sample-summary-block__actions">
      {actions?.map((action, idx) => (
        <a
          href={jsroutes[action.route]({ hash_value: hashValue })}
          className={`sample-summary-block__action-item ${action.class}`}
          key={idx}
        >
          {action.text}
        </a>
      ))}
    </div>
  );

  return (
    <div
      className={clsx(
        "sample-summary-block",
        overflowHidden && "sample-summary-block--overflow-hidden",
        icon && "sample-summary-block--with-icon",
        className && className
      )}
      id={id}
      ref={ref}
    >
      <div className="sample-summary-block__title-container">
        {count && (
          <div className="sample-summary-block__title-count">{count}</div>
        )}
        <h2 className="sample-summary-block__title">
          {title}
          {subtitle && (
            <div className="sample-summary-block__subtitle">{subtitle}</div>
          )}
          {titleLabel && (
            <span className="sample-summary-block__title-label">
              {titleLabel}
            </span>
          )}
          {blockActions}
        </h2>
        {icon && <Icon name={icon} className="sample-summary-block__icon" />}
      </div>
      <div className="sample-summary-block__main-content">{children}</div>
    </div>
  );
});

SummaryBlock.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleLabel: PropTypes.string,
  icon: PropTypes.string,
  overflowHidden: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.string,
      text: PropTypes.string,
      class: PropTypes.string
    })
  ),
  hashValue: PropTypes.string,
  id: PropTypes.string
};

export default SummaryBlock;
